import React from 'react';
import colors from '../../libs/colors';
import store from '../../store';

const badeg = {
  position: 'absolute',
  right: -15,
  top: -2,
  backgroundColor: colors.badgebg,
  borderRadius: 100,
  color: 'white',
  fontSize: 12,
  fontFamily: 'NSCJKrM',
  paddingLeft: 5,
  paddingRight: 5,
  lineHeight: '18px',
};
class MyBadge extends React.Component {
  componentDidMount() {}
  render() {
    const { children, onClick } = this.props;
    const { notice_count } = store.getState();
    
    return (
      <div
        onClick={onClick}
        style={{ position: 'relative', display: 'flex', alignContent: 'center', justifyContent: 'center' }}
      >
        <div style={badeg}>{notice_count.toLocaleString()}</div>
        {children}
      </div>
    );
  }
}

export default MyBadge;
